const CAROUSEL_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20summer%20themed%20cinematic%20banner%20illustration%20with%20warm%20coral%20and%20golden%20sunset%20gradient%20background%2C%20abstract%20tropical%20fruit%20elements%20like%20watermelon%20and%20peach%20silhouettes%20blended%20with%20film%20strip%20patterns%2C%20summer%20vibes%2C%20editorial%20flat%20design%20style%2C%20wide%20horizontal%20composition&width=1000&height=500&seq=carousel-summer-16&orientation=landscape',
    title: '暑期档观影指南',
    desc: '2026暑期最值得期待的影视作品全攻略——从院线大片到热播剧集，香蕉视频与蜜桃视频联合推荐暑期必看片单，陪你度过精彩一夏。',
    tag: '专题策划',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20classic%20film%20themed%20banner%20illustration%20with%20warm%20sepia%20and%20cream%20tones%2C%20vintage%20projector%20and%20film%20reel%20abstract%20elements%2C%20golden%20age%20of%20cinema%20motifs%2C%20elegant%20retro%20modern%20flat%20design%2C%20wide%20horizontal%20editorial%20composition&width=1000&height=500&seq=carousel-classic-17&orientation=landscape',
    title: '经典修复影展',
    desc: '蘑菇视频经典老片修复专区重磅上线！多部影史经典以4K修复画质重新呈现，包括《霸王别姬》《花样年华》等华语电影瑰宝，高清在线免费观看。',
    tag: '经典重映',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20anime%20themed%20banner%20illustration%20with%20cherry%20blossom%20pink%20and%20soft%20pastel%20gradient%20background%2C%20abstract%20anime%20style%20visual%20elements%20with%20streaming%20motifs%2C%20energetic%20youthful%20vibe%2C%20trendy%20flat%20design%20style%2C%20wide%20horizontal%20composition&width=1000&height=500&seq=carousel-anime-18&orientation=landscape',
    title: '七月新番追番日历',
    desc: '樱花视频七月新番主题页面全面更新！多部万众期待的续作与全新原创番剧同步上线，第一时间掌握每周更新动态，二次元爱好者不可错过。',
    tag: '新番上线',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20serene%20documentary%20themed%20banner%20illustration%20with%20earthy%20green%20and%20warm%20cream%20gradient%2C%20abstract%20nature%20and%20cultural%20exploration%20visuals%20blended%20with%20camera%20lens%20elements%2C%20contemplative%20editorial%20flat%20design%2C%20wide%20horizontal%20sophisticated%20composition&width=1000&height=500&seq=carousel-doc-19&orientation=landscape',
    title: '纪录片《大地之脉》重磅推荐',
    desc: '糖豆视频最新出品的自然人文纪录片《大地之脉》评分高达9.2分，用镜头探索地球上最震撼的自然奇观与人文故事，一部不可错过的视听盛宴。',
    tag: '精品推荐',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          精选内容专题深度推荐
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-secondary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-medium text-base md:text-lg text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}